export default __webpack_public_path__ + "f8783646622ea4163a1e4f5b466bb1a8.png";